<template>
  <div>
    <el-dropdown placement="bottom" @command="dropdownCommand">
      <el-badge :value="messageCount" :max="99" :hidden="messageCount === 0">
        <div style="display: flex;align-items: center;flex-direction: column;">
          <i class="el-icon-message text-gray-700 " style="font-size: 22px !important;"></i>
          <div style="font-size: 17px;">
            消息
          </div>
        </div>
      </el-badge>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled command="system">系统消息</el-dropdown-item>
        <el-dropdown-item command="privateLetter">
          <el-badge :value="privateLetterCount" :max="99" :hidden="privateLetterCount === 0">
            我的私信
          </el-badge>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>

import TIM from "tim-js-sdk";
import {mapState} from "vuex";
import {imLogin} from "@/utils/timUtils";

export default {
  name: "messageBar",
  data() {
    return {
      messageCount: 0,
      privateLetterCount: 0,
    }
  },
  filters: {},
  methods: {
    dropdownCommand(command) {
      switch (command) {
        case "privateLetter":
          this.$router.push({
            path: '/private-letter'
          })
          break
      }
    },
    isNumber(val) {
      const regPos = /^[0-9]+.?[0-9]*$/; // 判断是否是数字
      return regPos.test(val);
    }
  },
  computed: {
    ...mapState("user", ["userSig", "bindUuid"]),
  },
  created() {
    setTimeout(() => {
      imLogin(this.bindUuid, this.userSig)
    }, 1000)
    setTimeout(() => {
      this.privateLetterCount = this.$tim.getTotalUnreadMessageCount();
      if (this.isNumber(this.privateLetterCount)) {
        this.messageCount += this.privateLetterCount
      }
      this.$tim.on(TIM.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, (event) => {
        this.messageCount -= this.privateLetterCount
        this.privateLetterCount = event.data
        this.messageCount += this.privateLetterCount
      })
    }, 2000)
  },
}
</script>

<style scoped>

</style>